<template>
  <div>
    <VTextField
      v-model="key"
      :label="$t('deviceAnalysisKeys.key')"
      :disabled="true"
      outlined
    />
    <VTextField
      v-model="unit"
      :label="$t('deviceAnalysisKeys.unit')"
      :disabled="true"
      outlined
    />
    <VTextField
      v-model="data.option.option[selectedLang]"
      :label="`${$t('deviceAnalysisKeys.options.option')}(${selectedLang})`"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      @input="updateData"
    />
    <VTextField
      v-model="data.option.method[selectedLang]"
      :label="`${$t('deviceAnalysisKeys.options.method')}(${selectedLang})`"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      @input="updateData"
    />
    <VTextField
      v-model="data.option.minimum"
      :label="$t('deviceAnalysisKeys.options.minimum')"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      @input="updateData"
    />
    <VTextField
      v-model="data.option.maximum"
      :label="$t('deviceAnalysisKeys.options.maximum')"
      :rules="{ required: true, min: 1, max: 200, gEqual:[data.option.minimum] }"
      outlined
      @input="updateData"
    />
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { mapGetters } from 'vuex';

export default ({
    components: {
        VTextField,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        option: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                option: {
                    option: {},
                    method: {},
                    minimum: '',
                    maximum: '',
                },
            },
            unit: '',
            key: '',
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'selectedLang',
        ]),
    },


    async created() {
        if (this.isEdition) this.data.option = this.option;

        this.key = this.item.key;
        this.unit = this.item.unit[this.userLang] || this.item.unit[this.teamMainLang];
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data.option);
        },
    },
});
</script>
